import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AppContext from "./contexts/AppContext.context";
import { SnackbarProvider } from "./contexts/Snackbar.context";
import { BackdropProvider } from "./contexts/BackDrop.context";
import { Provider } from "react-redux";
import store from "./store/store";

const theme = createTheme({
  typography: {
    fontFamily: ["Plus Jakarta Sans"].join(","),
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <AppContext>
      <React.StrictMode>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <BackdropProvider>
              <SnackbarProvider>
                <App />
              </SnackbarProvider>
            </BackdropProvider>
          </ThemeProvider>
        </BrowserRouter>
      </React.StrictMode>
    </AppContext>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
